import * as React from 'react';
import Svg, {
    G,
    Rect,
    Path,
    Ellipse,
    Defs,
    RadialGradient,
    Stop,
    LinearGradient,
    ClipPath,
} from 'react-native-svg';

export default function BadgeOverview() {
    return (
        <Svg
            width={222}
            height={213}
            viewBox="0 0 222 213"
            fill="none"
        >
            <G clipPath="url(#clip0_332_23837)">
                <Rect x={0.762207} width={221} height={213} rx={10} fill="#fff" />
                <Path
                    fill="#E5A800"
                    d="M-4.1123 -22.2372H240.2217V277.56179999999995H-4.1123z"
                />
                <Path
                    d="M189.816-4.063c1.451-3.679 6.657-3.679 8.108 0l5.807 14.724 14.725 5.807c3.679 1.451 3.679 6.658 0 8.109l-14.725 5.807-5.807 14.724c-1.451 3.68-6.657 3.68-8.108 0l-5.808-14.724-14.724-5.807c-3.679-1.45-3.679-6.658 0-8.109l14.724-5.807 5.808-14.724zM107.904 5.494c1.451-3.679 6.658-3.679 8.108 0l5.808 14.724 14.724 5.807c3.679 1.451 3.679 6.658 0 8.109L121.82 39.94l-5.808 14.724c-1.45 3.68-6.657 3.68-8.108 0l-5.807-14.724-14.724-5.807c-3.68-1.451-3.68-6.658 0-8.109l14.724-5.807 5.807-14.724zM24.628-4.063c1.45-3.679 6.657-3.679 8.108 0l5.807 14.724 14.725 5.807c3.678 1.451 3.678 6.658 0 8.109l-14.725 5.807-5.807 14.724c-1.45 3.68-6.657 3.68-8.108 0L18.82 30.384 4.096 24.577c-3.679-1.45-3.679-6.658 0-8.109l14.724-5.807 5.808-14.724zM-12.233 65.562c1.451-3.679 6.658-3.679 8.109 0l5.807 14.724 14.724 5.807c3.68 1.451 3.68 6.658 0 8.109l-14.724 5.807-5.807 14.724c-1.451 3.679-6.658 3.679-8.109 0l-5.807-14.724-14.724-5.807c-3.68-1.451-3.68-6.658 0-8.109l14.724-5.807 5.807-14.724zM208.928 72.387c1.451-3.679 6.657-3.679 8.108 0l5.808 14.725 14.724 5.807c3.679 1.45 3.679 6.657 0 8.108l-14.724 5.807-5.808 14.725c-1.451 3.679-6.657 3.679-8.108 0l-5.807-14.725-14.725-5.807c-3.679-1.45-3.679-6.657 0-8.108l14.725-5.807 5.807-14.725zM165.242 147.473c1.451-3.679 6.657-3.679 8.108 0l5.808 14.724 14.724 5.807c3.679 1.451 3.679 6.658 0 8.109l-14.724 5.807-5.808 14.724c-1.451 3.679-6.657 3.679-8.108 0l-5.807-14.724-14.725-5.807c-3.679-1.451-3.679-6.658 0-8.109l14.725-5.807 5.807-14.724zM34.184 140.648c1.45-3.679 6.657-3.679 8.108 0l5.807 14.724 14.725 5.807c3.679 1.451 3.679 6.658 0 8.108l-14.725 5.808-5.807 14.724c-1.45 3.679-6.657 3.679-8.108 0l-5.807-14.724-14.725-5.808c-3.679-1.45-3.679-6.657 0-8.108l14.725-5.807 5.807-14.724zM-4.042 202.082c1.451-3.678 6.658-3.678 8.109 0l5.807 14.725 14.724 5.807c3.68 1.451 3.68 6.657 0 8.108L9.874 236.53l-5.807 14.724c-1.451 3.679-6.658 3.679-8.109 0l-5.807-14.724-14.724-5.808c-3.68-1.451-3.68-6.657 0-8.108l14.724-5.807 5.807-14.725zM94.252 203.447c1.451-3.679 6.658-3.679 8.109 0l5.807 14.724 14.724 5.807c3.679 1.451 3.679 6.658 0 8.109l-14.724 5.807-5.807 14.724c-1.451 3.679-6.658 3.679-8.109 0l-5.807-14.724-14.724-5.807c-3.68-1.451-3.68-6.658 0-8.109l14.724-5.807 5.807-14.724zM206.198 213.004c1.451-3.679 6.657-3.679 8.108 0l5.808 14.724 14.724 5.807c3.679 1.451 3.679 6.658 0 8.109l-14.724 5.807-5.808 14.724c-1.451 3.679-6.657 3.679-8.108 0l-5.807-14.724-14.725-5.807c-3.679-1.451-3.679-6.658 0-8.109l14.725-5.807 5.807-14.724z"
                    fill="#fff"
                    fillOpacity={0.15}
                />
                <G filter="url(#filter0_dd_332_23837)">
                    <Rect
                        x={42.2622}
                        y={37}
                        width={138}
                        height={139}
                        rx={69}
                        fill="#F0F0F3"
                    />
                    <Ellipse cx={111.262} cy={106.5} rx={69} ry={69.5} fill="#85249D" />
                    <Path
                        d="M152.538 115.521l-10.003.688c-2.686.197-3.793 3.474-1.746 5.178l7.687 6.291c1.678 1.377 4.229.656 4.901-1.376l2.282-6.849c.705-2.032-.94-4.096-3.121-3.932z"
                        fill="#F6C327"
                    />
                    <Path
                        d="M152.538 115.521l-10.003.688c-2.686.197-3.793 3.474-1.746 5.178l7.687 6.291c1.678 1.377 4.229.656 4.901-1.376l2.282-6.849c.705-2.032-.94-4.096-3.121-3.932z"
                        fill="url(#paint0_radial_332_23837)"
                    />
                    <Path
                        d="M152.538 115.521l-10.003.688c-2.686.197-3.793 3.474-1.746 5.178l7.687 6.291c1.678 1.377 4.229.656 4.901-1.376l2.282-6.849c.705-2.032-.94-4.096-3.121-3.932z"
                        fill="url(#paint1_linear_332_23837)"
                    />
                    <Path
                        d="M152.538 115.521l-10.003.688c-2.686.197-3.793 3.474-1.746 5.178l7.687 6.291c1.678 1.377 4.229.656 4.901-1.376l2.282-6.849c.705-2.032-.94-4.096-3.121-3.932z"
                        fill="url(#paint2_linear_332_23837)"
                    />
                    <Path
                        d="M129.268 69.456l-2.317 9.334c-.644 2.511 2.124 4.539 4.313 3.155l8.175-5.086c1.771-1.094 1.867-3.67.161-4.892l-5.729-4.153a2.934 2.934 0 00-4.603 1.642z"
                        fill="#F4C226"
                    />
                    <Path
                        d="M129.268 69.456l-2.317 9.334c-.644 2.511 2.124 4.539 4.313 3.155l8.175-5.086c1.771-1.094 1.867-3.67.161-4.892l-5.729-4.153a2.934 2.934 0 00-4.603 1.642z"
                        fill="url(#paint3_linear_332_23837)"
                    />
                    <Path
                        d="M129.268 69.456l-2.317 9.334c-.644 2.511 2.124 4.539 4.313 3.155l8.175-5.086c1.771-1.094 1.867-3.67.161-4.892l-5.729-4.153a2.934 2.934 0 00-4.603 1.642z"
                        fill="url(#paint4_linear_332_23837)"
                    />
                    <Path
                        d="M129.268 69.456l-2.317 9.334c-.644 2.511 2.124 4.539 4.313 3.155l8.175-5.086c1.771-1.094 1.867-3.67.161-4.892l-5.729-4.153a2.934 2.934 0 00-4.603 1.642z"
                        fill="url(#paint5_linear_332_23837)"
                    />
                    <Path
                        d="M79.96 76.87l8.144 5.085c2.189 1.384 4.957-.611 4.345-3.154l-2.317-9.335c-.515-2.027-2.897-2.896-4.603-1.673l-5.73 4.152c-1.705 1.287-1.609 3.83.162 4.925z"
                        fill="#EABA25"
                    />
                    <Path
                        d="M79.96 76.87l8.144 5.085c2.189 1.384 4.957-.611 4.345-3.154l-2.317-9.335c-.515-2.027-2.897-2.896-4.603-1.673l-5.73 4.152c-1.705 1.287-1.609 3.83.162 4.925z"
                        fill="url(#paint6_linear_332_23837)"
                    />
                    <Path
                        d="M79.96 76.87l8.144 5.085c2.189 1.384 4.957-.611 4.345-3.154l-2.317-9.335c-.515-2.027-2.897-2.896-4.603-1.673l-5.73 4.152c-1.705 1.287-1.609 3.83.162 4.925z"
                        fill="url(#paint7_linear_332_23837)"
                    />
                    <Path
                        d="M79.96 76.87l8.144 5.085c2.189 1.384 4.957-.611 4.345-3.154l-2.317-9.335c-.515-2.027-2.897-2.896-4.603-1.673l-5.73 4.152c-1.705 1.287-1.609 3.83.162 4.925z"
                        fill="url(#paint8_linear_332_23837)"
                    />
                    <Path
                        d="M72.734 127.462l7.37-6.18c1.996-1.674.934-4.925-1.641-5.085l-9.592-.676c-2.092-.161-3.67 1.866-3.026 3.862l2.19 6.727c.643 1.996 3.121 2.704 4.699 1.352z"
                        fill="#DFAD26"
                    />
                    <Path
                        d="M72.734 127.462l7.37-6.18c1.996-1.674.934-4.925-1.641-5.085l-9.592-.676c-2.092-.161-3.67 1.866-3.026 3.862l2.19 6.727c.643 1.996 3.121 2.704 4.699 1.352z"
                        fill="url(#paint9_linear_332_23837)"
                    />
                    <Path
                        d="M72.734 127.462l7.37-6.18c1.996-1.674.934-4.925-1.641-5.085l-9.592-.676c-2.092-.161-3.67 1.866-3.026 3.862l2.19 6.727c.643 1.996 3.121 2.704 4.699 1.352z"
                        fill="url(#paint10_linear_332_23837)"
                    />
                    <Path
                        d="M116.541 150.933l-3.605-8.916c-.966-2.414-4.378-2.414-5.343 0l-3.605 8.916c-.773 1.931.643 4.055 2.736 4.055h7.081c2.092-.032 3.508-2.124 2.736-4.055z"
                        fill="#E3B028"
                    />
                    <Path
                        d="M116.541 150.933l-3.605-8.916c-.966-2.414-4.378-2.414-5.343 0l-3.605 8.916c-.773 1.931.643 4.055 2.736 4.055h7.081c2.092-.032 3.508-2.124 2.736-4.055z"
                        fill="url(#paint11_linear_332_23837)"
                    />
                    <Path
                        d="M116.541 150.933l-3.605-8.916c-.966-2.414-4.378-2.414-5.343 0l-3.605 8.916c-.773 1.931.643 4.055 2.736 4.055h7.081c2.092-.032 3.508-2.124 2.736-4.055z"
                        fill="url(#paint12_linear_332_23837)"
                    />
                    <Path
                        d="M116.541 150.933l-3.605-8.916c-.966-2.414-4.378-2.414-5.343 0l-3.605 8.916c-.773 1.931.643 4.055 2.736 4.055h7.081c2.092-.032 3.508-2.124 2.736-4.055z"
                        fill="url(#paint13_linear_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint14_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint15_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint16_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint17_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint18_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint19_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint20_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint21_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint22_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint23_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint24_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint25_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint26_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint27_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint28_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint29_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint30_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint31_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint32_radial_332_23837)"
                    />
                    <Path
                        d="M115.798 71.493l5.558 11.972c1.048 2.235 3.113 3.8 5.527 4.15l13.054 2.012c5.907.894 8.289 8.142 4.16 12.42l-9.941 10.249a7.35 7.35 0 00-1.969 6.321l2.287 14.08c.984 6.066-5.432 10.6-10.799 7.631l-10.958-6.099a7.242 7.242 0 00-7.114 0l-10.958 6.099c-5.368 2.969-11.783-1.565-10.799-7.631l2.287-14.08a7.35 7.35 0 00-1.97-6.321l-9.94-10.249c-4.161-4.31-1.747-11.526 4.16-12.42l13.054-2.011a7.425 7.425 0 005.527-4.15l5.558-11.973c2.636-5.683 10.64-5.683 13.276 0z"
                        fill="url(#paint33_radial_332_23837)"
                    />
                </G>
            </G>
            <Defs>
                <RadialGradient
                    id="paint0_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(12.07033 -6.23634 8.65033 16.74256 144.257 122.452)"
                >
                    <Stop offset={0.746579} stopColor="#FFF055" stopOpacity={0} />
                    <Stop offset={1} stopColor="#FFF055" />
                </RadialGradient>
                <LinearGradient
                    id="paint1_linear_332_23837"
                    x1={147.778}
                    y1={114.328}
                    x2={149.695}
                    y2={126.655}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#FFF659" />
                    <Stop offset={0.324993} stopColor="#FFF659" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint2_linear_332_23837"
                    x1={146.168}
                    y1={125.594}
                    x2={158.395}
                    y2={111.774}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#E6B54A" />
                    <Stop offset={0.0892553} stopColor="#E6B54A" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint3_linear_332_23837"
                    x1={138.826}
                    y1={68.7391}
                    x2={136.613}
                    y2={72.0585}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#FFF659" />
                    <Stop offset={1} stopColor="#FFF659" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint4_linear_332_23837"
                    x1={136.512}
                    y1={69.2656}
                    x2={133.293}
                    y2={74.0937}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#FFF659" />
                    <Stop offset={0.557692} stopColor="#FFF659" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint5_linear_332_23837"
                    x1={128.465}
                    y1={74.0937}
                    x2={138.122}
                    y2={77.3125}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#EAB72B" />
                    <Stop offset={0.170312} stopColor="#EAB72B" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint6_linear_332_23837"
                    x1={91.4497}
                    y1={72.4843}
                    x2={85.006}
                    y2={74.0909}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#FFF659" />
                    <Stop offset={0.363812} stopColor="#FFF659" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint7_linear_332_23837"
                    x1={81.7935}
                    y1={69.2656}
                    x2={85.0014}
                    y2={74.1047}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#FFF659" />
                    <Stop offset={0.363812} stopColor="#FFF659" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint8_linear_332_23837"
                    x1={81.7935}
                    y1={78.9218}
                    x2={86.6141}
                    y2={70.8705}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop offset={0.071232} stopColor="#E4A829" />
                    <Stop offset={0.20374} stopColor="#E4A829" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint9_linear_332_23837"
                    x1={73.4213}
                    y1={115.512}
                    x2={73.4213}
                    y2={118.73}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#DEAE2C" />
                    <Stop offset={1} stopColor="#DEAE2C" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint10_linear_332_23837"
                    x1={76.9653}
                    y1={125.594}
                    x2={65.6997}
                    y2={111.109}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop offset={0.0608173} stopColor="#D89C40" />
                    <Stop offset={0.174519} stopColor="#D89C40" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint11_linear_332_23837"
                    x1={115.993}
                    y1={147.597}
                    x2={112.472}
                    y2={149.107}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#F9C83C" />
                    <Stop offset={1} stopColor="#F9C83C" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint12_linear_332_23837"
                    x1={105.934}
                    y1={146.516}
                    x2={128.465}
                    y2={152.953}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#D89C40" />
                    <Stop offset={0.0704617} stopColor="#D89C40" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint13_linear_332_23837"
                    x1={109.153}
                    y1={156.172}
                    x2={109.153}
                    y2={140.078}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop offset={0.09375} stopColor="#D89C40" />
                    <Stop offset={0.18125} stopColor="#D89C40" stopOpacity={0} />
                </LinearGradient>
                <RadialGradient
                    id="paint14_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-36.08661 38.81887 -38.41355 -35.70982 131.698 85.725)"
                >
                    <Stop stopColor="#FFEAAE" />
                    <Stop offset={1} stopColor="#F7C632" />
                </RadialGradient>
                <RadialGradient
                    id="paint15_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="rotate(90 2.453 106.7) scale(37.0156)"
                >
                    <Stop stopColor="#DDBA38" />
                    <Stop offset={1} stopColor="#DDBA38" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint16_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(9.27946 -5.30773 6.158 10.76597 144.843 91.115)"
                >
                    <Stop offset={0.0027979} stopColor="#FFF249" />
                    <Stop offset={0.686538} stopColor="#FFF249" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint17_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(6.62821 6.6347 -16.15396 16.13818 139.54 105.712)"
                >
                    <Stop offset={0.125} stopColor="#E5B23C" />
                    <Stop offset={0.95} stopColor="#E5B23C" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint18_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="rotate(-58.521 173.333 -8.647) scale(7.50377 7.50777)"
                >
                    <Stop stopColor="#D69E1F" />
                    <Stop offset={1} stopColor="#D69E1F" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint19_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-5.15578 2.8901 -3.80208 -6.78272 148.971 92.91)"
                >
                    <Stop stopColor="#FFF246" />
                    <Stop offset={1} stopColor="#FFF246" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint20_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="rotate(21.821 -295.92 421.75) scale(7.13977 3.57241)"
                >
                    <Stop stopColor="#FFF246" />
                    <Stop offset={1} stopColor="#FFF246" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint21_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(17.23338 -17.25023 17.25016 17.23331 124.958 85.808)"
                >
                    <Stop offset={0.113127} stopColor="#FFF249" />
                    <Stop offset={0.298269} stopColor="#FFF249" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint22_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="rotate(-18.452 445.632 -351.743) scale(16.7698 35.008)"
                >
                    <Stop offset={0.0592265} stopColor="#FFF249" />
                    <Stop offset={0.39519} stopColor="#FFF249" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint23_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(21.21033 1.32694 -.35828 5.72682 135.564 89.788)"
                >
                    <Stop offset={0.26571} stopColor="#FFF249" />
                    <Stop offset={0.738695} stopColor="#FFF249" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint24_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="rotate(74.49 10.798 113.217) scale(24.7875 6.68062)"
                >
                    <Stop offset={0.26571} stopColor="#FFF249" />
                    <Stop offset={0.738695} stopColor="#FFF249" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint25_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-3.97695 -26.53877 7.15191 -1.07174 135.564 136.231)"
                >
                    <Stop offset={0.26571} stopColor="#FFF249" />
                    <Stop offset={0.738695} stopColor="#FFF249" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint26_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="rotate(74.069 -16.091 100.898) scale(6.01098 20.0436)"
                >
                    <Stop stopColor="#F5DC40" />
                    <Stop offset={1} stopColor="#F5DC40" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint27_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(10.01432 2.89005 -2.89529 10.03248 72.137 92.497)"
                >
                    <Stop stopColor="#D69F20" />
                    <Stop offset={1} stopColor="#D69F20" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint28_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-12.87494 27.3594 -9.11443 -4.28912 102.715 70.875)"
                >
                    <Stop offset={0.0888889} stopColor="#D79F21" />
                    <Stop offset={0.738695} stopColor="#D79F21" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint29_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(23.8616 26.53879 -9.42871 8.47756 73.258 100.404)"
                >
                    <Stop offset={0.121202} stopColor="#D69E20" />
                    <Stop offset={0.738695} stopColor="#D69E20" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint30_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="rotate(100.61 -9.54 98.164) scale(21.6003 8.9071)"
                >
                    <Stop offset={0.121202} stopColor="#D69E20" />
                    <Stop offset={0.738695} stopColor="#D69E20" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint31_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-18.55912 9.28845 -4.48098 -8.95338 99.771 137.558)"
                >
                    <Stop offset={0.121202} stopColor="#DCA636" />
                    <Stop offset={0.738695} stopColor="#DCA636" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint32_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="rotate(28.324 -210.777 302.586) scale(19.5772 7.12076)"
                >
                    <Stop offset={0.121202} stopColor="#D69E22" />
                    <Stop offset={0.738695} stopColor="#D69E22" stopOpacity={0} />
                </RadialGradient>
                <RadialGradient
                    id="paint33_radial_332_23837"
                    cx={0}
                    cy={0}
                    r={1}
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(-5.30263 9.2886 -11.64956 -6.65045 83.864 138.885)"
                >
                    <Stop offset={0.144231} stopColor="#D69E20" />
                    <Stop offset={0.738695} stopColor="#D69E20" stopOpacity={0} />
                </RadialGradient>
                <ClipPath id="clip0_332_23837">
                    <Rect x={0.762207} width={221} height={213} rx={10} fill="#fff" />
                </ClipPath>
            </Defs>
        </Svg>
    );
}
